import { Attribute } from 'proto/Accommodation/Attributes';

export const availableSpotActivityList = [
    Attribute.Diving,
    Attribute.Golf,
    Attribute.Hiking,
    Attribute.Kitesurfing,
    Attribute.Surfing,
    Attribute.Wingfoiling,
    Attribute.Windsurfing,
    Attribute.WinterSports,
];

export const availableAttributListMap: Record<string, string | undefined> = {
    [Attribute.Diving]: 'TRANS-diving',
    [Attribute.Golf]: 'TRANS-golfing',
    [Attribute.Hiking]: 'TRANS-hiking',
    [Attribute.Kitesurfing]: 'TRANS-kite-surfing',
    [Attribute.Surfing]: 'TRANS-surfing',
    [Attribute.Windsurfing]: 'TRANS-wind-surfing',
    [Attribute.Wingfoiling]: 'TRANS-wing-foiling',
    [Attribute.WinterSports]: 'TRANS-skiing',
};
